import { useCallback, useState } from "react";

export default function useConfirmDialog(defaults = {}) {
  const [confirmProps, setConfirmProps] = useState({ open: false, ...defaults });

  const closeConfirm = useCallback(() => {
    setConfirmProps((prev) => ({ ...prev, open: false }));
  }, []);

  const openConfirm = useCallback(
    (config) => {
      setConfirmProps({
        open: true,
        title: config.title || defaults.title || "Confirm Action",
        message: config.message,
        confirmLabel: config.confirmLabel || defaults.confirmLabel || "Confirm",
        cancelLabel: config.cancelLabel || defaults.cancelLabel || "Cancel",
        variant: config.variant || defaults.variant || "primary",
        alternateLabel: config.alternateLabel,
        alternateVariant: config.alternateVariant || "outline",
        onCancel: () => {
          config.onCancel?.();
          closeConfirm();
        },
        onConfirm: async () => {
          await config.onConfirm?.();
          closeConfirm();
        },
        onAlternate: config.onAlternate
          ? async () => {
              await config.onAlternate?.();
              closeConfirm();
            }
          : undefined,
      });
    },
    [closeConfirm, defaults.cancelLabel, defaults.confirmLabel, defaults.title, defaults.variant]
  );

  return { confirmProps, openConfirm, closeConfirm };
}
